import { render, staticRenderFns } from "./miscTreatyInfo1.vue?vue&type=template&id=2764626d&"
import script from "./miscTreatyInfo1.vue?vue&type=script&lang=js&"
export * from "./miscTreatyInfo1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports